import {
    useState
} from 'react';
import {
    Container
} from './styled';
import {
    FaCheck
} from "react-icons/fa6";
import {
    renameGroup
} from '../../../../../service/serviceChat/groupService';
import { toast } from 'react-toastify';

export function RenameGroup({ group, callback }) {

    const { nomecompleto, id } = group;

    const [nameGroup, setNameGroup] = useState(nomecompleto);

    async function handleSave() {
        if (nameGroup === '') {
            toast.warn('Nome do setor não pode ser vazio',
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            return;
        }
        const response = await renameGroup({
            id: id,
            name: nameGroup
        });
        if (response) {
            toast.success('Setor renomeado com sucesso !',
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            callback();
        }else{
            toast.error('Erro ao renomear setor !',
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
        }
    };

    return (
        <Container>
            <div>
                <input type="text" value={id} disabled={true}/>
            </div>
            <div>
                <input
                    type="text"
                    name="nameG"
                    id="nameG"
                    value={nameGroup}
                    onChange={(e) => setNameGroup(e.target.value)}
                    placeholder='Nome do Setor'
                />
                <span>
                    <FaCheck
                        fontSize={20}
                        onClick={() => handleSave()}
                    />
                </span>
            </div>
        </Container>
    )
}